import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { NotificacionesPushService } from 'src/app/services/auth/notificaciones-push.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';
import { ActualizaDatosService } from 'src/app/services/auth/actualiza-datos/actualiza-datos.service';
import { IRequestVaidacion2FA } from 'src/app/models/account/account.model';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatError } from '@angular/material/form-field';

import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
@Component({
    selector: 'app-validador-dos-fa',
    templateUrl: './validador-dos-fa.component.html',
    styleUrls: ['./validador-dos-fa.component.scss'],
    imports: [CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatError, MatButton, MatDialogActions]
})
export class ValidadorDosFaComponent {
  @ViewChild('twoFactorCodeInput') twoFactorCodeInput: ElementRef<HTMLInputElement>;
  constructor(
    public dialogRef: MatDialogRef<ValidadorDosFaComponent>,
    private notiPushService: NotificacionesPushService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService, private router: Router, private actDatos: ActualizaDatosService,
    private snackBar: MatSnackBar,) { }

  formTwoFactorCode = new FormGroup({
    TwoFactorCode: new FormControl(null, Validators.required),
  });
  bloqueoCodigo = false;
  loading = false;
  reenvio = true;
  procesando = false;
  msgError = '';
  autenticacionOcultar = false;
  dobleFactroOcultar = true;
  timer: any;
  intervalo: number = 0;
  maskedEmail: string = '';
  maskedPhone: string = '';
  tiempoBloqueo: number = 0;
  contadorIntentos: number = 0;
  intentos: number = 0;
  colorBotones: string = "#ef3c46";

  ngOnInit() {
    if (this.data.tipo == "Correo Electronico") {
      this.SolcitarDobleFactorValidacionEmail(this.data);
    } else if (this.data.tipo == "Telefono") {
      this.SolcitarDobleFactorValidacionTelefono(this.data);
    }
  }
  public SolcitarDobleFactorValidacionEmail(valor: any) {
    this.procesando = true;
    if (this.twoFactorCodeInput) {
      this.twoFactorCodeInput.nativeElement.value = '';
    }
    const request: IRequestVaidacion2FA = {
      TipoEnvio: valor.tipo,
      Valor: valor.valor,
      Usuario: valor.usuario,
      TwoFactorCode: ""
    }
    this.authService.CodigoValidacionTwoFactorCodeEmail(request).pipe(
    ).subscribe((data) => {
      if (data.datos.Intervalo > 0) {
        this.msgError = '';
        this.reenvio = true;
        this.bloqueoCodigo = false;
        this.procesando = false;
        this.autenticacionOcultar = true;
        this.dobleFactroOcultar = false;
        this.intervalo = data.datos.Intervalo;
        this.maskedEmail = data.datos.MaskedEmail;
        this.maskedPhone = data.datos.MaskedPhone;
        this.tiempoBloqueo = data.datos.TiempoBloqueo;
        this.intentos = data.datos.Intentos;
        this.notificacionEnvio(valor.tipo);
        this.startCountdown();
        setTimeout(() => {
          this.twoFactorCodeInput.nativeElement.focus();
        }, 5);
      }
    }, (error) => {
      Swal.fire({
        title: 'Aviso',
        text: 'Ocurrió un error al validar el código.',
        icon: 'error',
        confirmButtonColor: this.colorBotones,
      });
      const request: IRequestVaidacion2FA = {
        TipoEnvio: "",
        Valor: "Ocurrió un error al validar el código.",
        TwoFactorCode: ""
      }
      this.closeDialog(request)
    }
    );
  }
  public notificacionEnvio(tipo: any) {
    Swal.fire({
      title: `¡Informativo!`,
      icon: 'info',
      html: `Estimados usuario, <br/>
          Le hemos enviado a su ${tipo} un codigo de autentificacion de dos factores (2FA) favor de revisarlo.
        `,
      confirmButtonText: 'Aceptar',
      allowOutsideClick: false,
      confirmButtonColor: this.colorBotones,
    });
  }
  public SolcitarDobleFactorValidacionTelefono(valor: any) {
    this.procesando = true;
    if (this.twoFactorCodeInput) {
      this.twoFactorCodeInput.nativeElement.value = '';
    }
    const request: IRequestVaidacion2FA = {
      TipoEnvio: valor.tipo,
      Valor: valor.valor,
      Usuario: valor.usuario,
      TwoFactorCode: ""
    }
    this.authService.CodigoValidacionTwoFactorCodeTelefono(request).pipe(
    ).subscribe((data) => {
      if (data.datos.Intervalo > 0) {
        this.msgError = '';
        this.bloqueoCodigo = false;
        this.procesando = false;
        this.autenticacionOcultar = true;
        this.dobleFactroOcultar = false;
        this.reenvio = true;
        this.intervalo = data.datos.Intervalo;
        this.maskedEmail = data.datos.MaskedEmail;
        this.maskedPhone = data.datos.MaskedPhone;
        this.tiempoBloqueo = data.datos.TiempoBloqueo;
        this.intentos = data.datos.Intentos;
        this.notificacionEnvio(valor.tipo);
        this.startCountdown();
        setTimeout(() => {
          this.twoFactorCodeInput.nativeElement.focus();
        }, 5);
      }
    }, (error) => {
      Swal.fire({
        title: 'Aviso',
        text: 'Ocurrió un error al validar el código.',
        icon: 'error',
        confirmButtonColor: this.colorBotones,
      });
      const request: IRequestVaidacion2FA = {
        TipoEnvio: "",
        Valor: "Ocurrió un error al validar el código.",
        TwoFactorCode: ""
      }
      this.closeDialog(request)
    }
    );
  }
  public ValidarCodigoTwoFactorCode() {
    this.procesando = true;
    const request: IRequestVaidacion2FA = {
      TipoEnvio: this.data.tipo,
      Valor: this.data.valor,
      TwoFactorCode: this.formTwoFactorCode.get("TwoFactorCode").value
    }
    this.authService.ValidacionTwoFactorCode(request).pipe(
    ).subscribe((data) => {
      if (data.validacion == true) {
        this.procesando = false;
        Swal.fire({
          icon: 'success',
          title: 'Validacion exitosa',
          text: 'La validacion ha sido exitosa',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: this.colorBotones,
        });
        this.closeDialog(request)
      } else {
        this.procesando = false;
        Swal.fire({
          title: 'Aviso',
          text: 'Ocurrió un error al validar el código',
          icon: 'error',
          confirmButtonColor: this.colorBotones,
        });
      }

    }, (error) => {
      this.procesando = false;
      Swal.fire({
        title: 'Aviso',
        text: error.error.errorDescripcion,
        icon: 'error',
        confirmButtonColor: this.colorBotones,
      });
      if (error.error.errorDescripcion != "La autentificacion no fue correcta.") {
        const request: IRequestVaidacion2FA = {
          TipoEnvio: "",
          Valor: "Ocurrió un error al validar el código.",
          TwoFactorCode: ""
        }
        this.closeDialog(request)
      }

    }
    );

  }
  startCountdown(): void {
    this.timer = setInterval(() => {
      this.intervalo--;

      if (this.intervalo <= 0) {
        Swal.fire({
          title: 'Aviso',
          text: 'El código ha expirado. Por favor, solicita un nuevo código.',
          icon: 'error',
          confirmButtonColor: this.colorBotones,
        });
        this.bloqueoCodigo = true;
        this.reenvio = false;
        clearInterval(this.timer);
        this.intervalo = 0;
      }
    }, 1000);
  }
  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
  public resendCode() {
    if (this.data.tipo == "Correo Electronico")
      this.SolcitarDobleFactorValidacionEmail(this.data);
    else if (this.data.tipo == "Telefono")
      this.SolcitarDobleFactorValidacionTelefono(this.data);

  }

  closeDialog(data: any) {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.dialogRef.close(data);
  }
}
